/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

const baseURL = process.env.VUE_APP_BASE_API

//价格显示
export function handleMoney(value) {
    const newValue = ["", "", ""];
    let fr = 1000;
    let num = 3;
    let text1 = "";
    let fm = 1;
    while (value / fr >= 1) {
        fr *= 10;
        num += 1;
    }
    if (num <= 4) {
        // 千
        newValue[0] = parseInt(value / 1000) + "";
        newValue[1] = "元";
    } else if (num <= 8) {
        // 万
        text1 = parseInt(num - 4) / 3 > 1 ? "千万" : "万";
        // tslint:disable-next-line:no-shadowed-variable
        fm = text1 === "万" ? 10000 : 10000000;
        if (value % fm === 0) {
            newValue[0] = parseInt(value / fm) + "";
        } else {
            newValue[0] = parseFloat(value / fm).toFixed(2) + "";
        }
        newValue[1] = text1;
    } else if (num <= 16) {
        // 亿
        text1 = (num - 8) / 3 > 1 ? "千亿" : "亿";
        text1 = (num - 8) / 4 > 1 ? "万亿" : text1;
        text1 = (num - 8) / 7 > 1 ? "千万亿" : text1;
        // tslint:disable-next-line:no-shadowed-variable
        fm = 1;
        if (text1 === "亿") {
            fm = 100000000;
        } else if (text1 === "千亿") {
            fm = 100000000000;
        } else if (text1 === "万亿") {
            fm = 1000000000000;
        } else if (text1 === "千万亿") {
            fm = 1000000000000000;
        }
        if (value % fm === 0) {
            newValue[0] = parseInt(value / fm) + "";
        } else {
            newValue[0] = parseFloat(value / fm).toFixed(2) + "";
        }
        newValue[1] = text1;
    }
    if (value < 9999) {
        newValue[0] = value + "";
        newValue[1] = "元";
    }
    return newValue.join("");
}
//信用代码校验
export function CheckSocialCreditCode(Code) {
    var patrn = /^[0-9A-Z]+$/
    //18位校验及大写校验
    if ((Code.length != 18) || (patrn.test(Code) == false)) {
        return false
    } else {
        var Ancode//统一社会信用代码的每一个值
        var Ancodevalue//统一社会信用代码每一个值的权重
        var total = 0
        var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]//加权因子
        var str = '0123456789ABCDEFGHJKLMNPQRTUWXY'
        //不用I、O、S、V、Z
        for (var i = 0; i < Code.length - 1; i++) {
            Ancode = Code.substring(i, i + 1)
            Ancodevalue = str.indexOf(Ancode)
            total = total + Ancodevalue * weightedfactors[i]
            //权重与加权因子相乘之和
        }
        var logiccheckcode = 31 - total % 31
        if (logiccheckcode == 31) {
            logiccheckcode = 0
        }
        var Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y'
        var Array_Str = Str.split(',')
        logiccheckcode = Array_Str[logiccheckcode]

        var checkcode = Code.substring(17, 18)
        if (logiccheckcode != checkcode) {
            return false
        }
    }
    return true
}

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    var search = params;
    search.params = {};
    if (null != dateRange && '' != dateRange) {
        if (typeof (propName) === "undefined") {
            search.params["beginTime"] = dateRange[0];
            search.params["endTime"] = dateRange[1];
        } else {
            search.params["begin" + propName] = dateRange[0];
            search.params["end" + propName] = dateRange[1];
        }
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    if (value === null) {
        return '-';
    } else {
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue === ('' + value)) {
                actions.push(datas[key].dictLabel);
                return true;
            }
        })
        return actions.join('');
    }
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    var actions = [];
    var currentSeparator = undefined === separator ? "," : separator;

    if (value === null) {
        return '-';
    } else {
        var temp = value.split(currentSeparator);
        Object.keys(value.split(currentSeparator)).some((val) => {
            Object.keys(datas).some((key) => {
                if (datas[key].dictValue == ('' + temp[val])) {
                    actions.push(datas[key].dictLabel + currentSeparator);
                }
            })
        })
    }
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 通用下载方法
export function download(fileName) {
    window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments, flag = true, i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
    let result = ''
    Object.keys(params).forEach((key) => {
        if (!Object.is(params[key], undefined) && !Object.is(params[key], null) && !Object.is(JSON.stringify(params[key]), '{}')) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
        }
    })
    return result
}

